import { css } from 'styled-components';
import { layouts } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

export default css`
    padding: ${getBaseTheme().spaces.inset.xs};
    ${layouts.VerticalBoxDivider} {
        background-color: ${getBaseTheme().colors.area.default.backgroundColor};
        margin-left: -${getBaseTheme().spaces.default.xs};
        margin-right: -${getBaseTheme().spaces.default.xs};
        height: ${getBaseTheme().sizes.xxxs};
    }

    .app-version {
        padding-top: ${getBaseTheme().spaces.default.xs};
    }

    .user-info {
        padding-bottom: ${getBaseTheme().spaces.default.xs};
        span {
            font-size: ${getBaseTheme().texts.sizes.s.fontSize};
        }
    }

    .release-link {
        padding: 0;
        border: 0;
        background-color: transparent;
        cursor: pointer;
        font-size: ${getBaseTheme().texts.sizes.s.fontSize};
        letter-spacing: ${getBaseTheme().texts.sizes.s.letterSpacing};
        line-height: ${getBaseTheme().texts.sizes.s.lineHeight};

        &:hover {
            text-decoration: underline;
        }

        &:active {
            color: blue;
        }
    }
`;
